import { useEffect } from 'react'
import { useMsal } from '@azure/msal-react'

const DISABLE_AUTH = import.meta.env.VITE_DISABLE_AUTH === 'true'

// Matches Blazor Web appsettings IdleTimeout="30" and Utilities.js timeout calculation.
const IDLE_TIMEOUT_MINUTES = 30
const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000

/**
 * Mirrors Blazor wwwroot/js/Utilities.js inactivity behavior:
 * - reset timer on mouse move / key press
 * - trigger logoutRedirect after idle timeout
 */
export function useInactivityLogout(): void {
  const { instance } = useMsal()

  useEffect(() => {
    if (DISABLE_AUTH) return

    let timer: ReturnType<typeof window.setTimeout> | null = null

    const logout = () => {
      void instance.logoutRedirect()
    }

    const resetTimer = () => {
      if (timer) {
        window.clearTimeout(timer)
      }
      timer = window.setTimeout(logout, IDLE_TIMEOUT_MS)
    }

    document.addEventListener('mousemove', resetTimer)
    document.addEventListener('keypress', resetTimer)

    return () => {
      document.removeEventListener('mousemove', resetTimer)
      document.removeEventListener('keypress', resetTimer)
      if (timer) {
        window.clearTimeout(timer)
      }
    }
  }, [instance])
}
